<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <template v-if="CheckAdmin">
        <v-card>
          <v-card-title style="color: white" class="light-blue lighten-2">
            จัดการข้อมูลสิทธิ์การใช้งาน
          </v-card-title>
          <v-tabs
              v-model="tabTitle"
              grow
          >
            <v-tab
                key="ManagePermiss"
            >
              <span style="font-weight: bold; color: black;font-size: 16px">จัดการข้อมูลสิทธิ์การใช้งาน</span>
            </v-tab>
            <!--          <v-tab-->
            <!--              key="ManageLevel"-->
            <!--          >-->
            <!--            <span style="font-weight: bold; color: black;font-size: 16px">การอนุมัติโครงการ</span>-->
            <!--          </v-tab>-->
          </v-tabs>

          <v-tabs-items v-model="tabTitle">
            <v-tab-item
                key="ManagePermiss"
            >
              <v-card-text>
                <v-container>
                  <v-card>
                    <v-row
                        class="md12 d-flex justify-center"
                    >
                      <v-col
                          cols="12"
                          md="5"
                      >
                        <!--<v-responsive
                                class="text-center grey lighten-2 rounded-circle d-inline-flex align-center justify-center ma-3"
                                height="64"
                                width="64"
                        >
                            Circle
                        </v-responsive>-->  <!-- v-respronseive -->
                        <h2 class="ml-3">
                          บุคลากร
                        </h2>
                        <v-autocomplete v-model="perid" :items="StaffData" clearable
                                        item-text="fullDetail"
                                        item-value="perid"
                                        label="ค้นหาบุคลากร" @change="ChoosePerson">
                        </v-autocomplete>
                        <div align="center">
                            <h2><span style="font-weight: bold;color: blueviolet">
                            รหัสบุคลากรที่เลือก : {{ perid }}
                          </span></h2>
                        </div>
                        <v-text-field label="ค้นหารายชื่อบุคลากรที่ได้รับสิทธิ์" v-model="searchPermiss"></v-text-field>
                        <v-list-item class="mt-10">
                          <v-data-table :items="DataToShowCopy" :headers="HeaderPermiss" :search="searchPermiss">
                            <template v-slot:item.Custom="{item}">
                              <div v-html="item.Custom"></div>
                            </template>
                            <template v-slot:item.action="{ item }">
                              <v-btn color="blue" @click="ShowDetailPermiss(item)" text>
                                สิทธิ์การใช้งาน
                              </v-btn>
                              <v-btn color="red" @click="DeletePermiss(item)" text>
                                ลบ
                              </v-btn>
                            </template>
                          </v-data-table>
                        </v-list-item>
                      </v-col>
                      <v-divider vertical>
                      </v-divider>
                      <v-col
                          cols="12"
                          md="5"
                      >
                        <!--<v-responsive
                                class="text-center grey lighten-2 rounded-circle d-inline-flex align-center justify-center ma-3"
                                height="64"
                                width="64"
                        >
                            Circle
                        </v-responsive>-->  <!-- v-respronseive -->
                        <v-responsive>
                          <v-list-item>
                            <v-tabs
                                v-model="tab"
                                show-arrows
                            >
                              <v-tab
                                  key="1"
                              >
                                <h3 style="font-weight: bold">
                                  สิทธิ์การใช้งาน
                                </h3>
                              </v-tab>
                              <v-tab
                                  key="2"
                              >
                                <h3 style="font-weight: bold">
                                  สิทธิ์หน่วยงาน
                                </h3>
                              </v-tab>
                            </v-tabs>
                          </v-list-item>
                          <v-tabs-items v-model="tab">
                            <v-tab-item key="1">
                              <v-spacer></v-spacer>
                              <v-checkbox label="เลือกทั้งหมด" color="green"
                                          @change="CheckAllPermiss"
                                          v-model="CheckAllOption"></v-checkbox>
                              <v-list-item v-for="(permiss_i, idx) in PermissionMsData.filter(item => !item.disable)"
                                           v-bind:key="idx">
                                <v-checkbox :label="permiss_i.detail" color="green"
                                            v-model="permiss_i.permiss">
                                  <template v-slot:label>
                                                              <span
                                                                  style="font-weight: bold;font-size: 16px;color: darkgreen"
                                                                  v-if="permiss_i.permiss">{{ permiss_i.detail }}</span>
                                    <span style="font-weight: bold;font-size: 16px"
                                          v-else>{{ permiss_i.detail }}</span>
                                  </template>
                                </v-checkbox>
                              </v-list-item>
                            </v-tab-item>
                            <v-tab-item key="2">
                              <!--                                                <v-spacer></v-spacer>-->
                              <!--                                                <v-checkbox label="เลือกทั้งหมด" color="green" @change="CheckAllPermiss"-->
                              <!--                                                            v-model="CheckAllOption"></v-checkbox>-->
                              <!--                                                <v-list-item v-for="(depart_i, idx) in DepartData" v-bind:key="idx">-->
                              <!--                                                    <v-checkbox :label="depart_i.full_Name" color="green"-->
                              <!--                                                                v-model="depart_i.dep_permiss">-->
                              <!--                                                        <template v-slot:label>-->
                              <!--                                                            <span style="font-weight: bold;font-size: 16px;color: darkgreen"-->
                              <!--                                                                  v-if="depart_i.dep_permiss">{{depart_i.full_Name}}</span>-->
                              <!--                                                            <span style="font-weight: bold;font-size: 16px" v-else>{{depart_i.full_Name}}</span>-->
                              <!--                                                        </template>-->
                              <!--                                                    </v-checkbox>-->
                              <!--                                                </v-list-item>-->
                              <v-list-item>
                                <v-spacer></v-spacer>
                                <v-text-field v-model="search" label="ค้นหา"></v-text-field>
                              </v-list-item>
                              <v-list-item>
                                <v-spacer></v-spacer>
                                <v-btn text color="green" @click="ChooseAllDep">แสดงทั้งหมด</v-btn>
                                <v-btn text color="blue" @click="ChooseDepPermiss">แสดงเฉพาะหน่วยงานตามสิทธิ์</v-btn>
                              </v-list-item>
                              <v-data-table
                                  :search="search"
                                  :items="DepartDataDump"
                                  :headers="DepHeader"
                              >
                                <template v-slot:header.full_Name>
                                                          <span style="font-weight: bold;font-size: 16px">
                                                             หน่วยงาน
                                                          </span>
                                </template>
                                <template v-slot:header.action>
                                  <div align="center">
                                    <v-checkbox v-model="CheckAllDepart" color="red"
                                                label="สิทธิ์ทั้งหมด" @change="CheckAllPermissDep"></v-checkbox>
                                    <v-checkbox v-model="CheckAllSendmail" color="red"
                                                label="emailทั้งหมด" @change="CheckAllSendmailFunc"></v-checkbox>
                                  </div>
                                </template>
                                <template v-slot:item.full_Name="{item}">
                                                          <span
                                                              style="font-weight: bold;font-size: 16px;color: darkgreen"
                                                              v-if="item.dep_permiss">{{ item.full_Name }}</span>
                                  <span style="font-weight: bold;font-size: 16px" v-else>{{ item.full_Name }}</span>
                                </template>
                                <template v-slot:item.action="{item}">
                                  <v-checkbox class="font-weight-bold" v-model="item.dep_permiss" color="red"
                                              label="สิทธิ์"></v-checkbox>
                                  <v-checkbox class="font-weight-bold" v-model="item.sendmail" color="red"
                                              label="email"></v-checkbox>
                                </template>
                              </v-data-table>
                              <!--<v-list-item>
                                  <v-responsive class="text-center">
                                      <v-btn class="d-inline-flex ma-2" color="primary" outlined
                                             @click="SubmitDepartData">
                                          บันทึกสิทธิ์หน่วยงาน
                                      </v-btn>
                                      <v-btn class="d-inline-flex ma-2" color="red" outlined
                                             @click="cancelAllPermissDep">
                                          ยกเลิกสิทธิ์ทั้งหมด
                                      </v-btn>
                                  </v-responsive>
                              </v-list-item>-->
                            </v-tab-item>
                            <v-list-item>
                              <v-responsive class="text-center">
                                <v-btn class="d-inline-flex ma-2" color="primary" outlined
                                       @click="SubmitData">
                                  บันทึกสิทธิ์
                                </v-btn>
                                <!--                              <v-btn class="d-inline-flex ma-2" color="red" outlined-->
                                <!--                                     @click="cancelAllPermiss">-->
                                <!--                                ยกเลิกสิทธิ์ทั้งหมด-->
                                <!--                              </v-btn>-->
                              </v-responsive>
                            </v-list-item>
                          </v-tabs-items>
                        </v-responsive>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-container>
              </v-card-text>
            </v-tab-item>
            <v-tab-item
                key="ManageLevel"
            >
              <v-card-text>
                <v-container>
                  <v-card>
                    <v-list-item class="align-center">
                      <v-autocomplete label="หน่วยงาน" :items="DepartData" item-text="dep_name"
                                      item-value="dep_id" color="red"
                                      v-model="dep_id" @change="ChooseApproveDep"></v-autocomplete>
                    </v-list-item>
                    <v-list-item class="align-center justify-center">
                      <v-checkbox label="เลือกหน่วยงานทั้งหมด"
                                  style="transform: scale(1.2)"></v-checkbox>
                    </v-list-item>
                    <v-row
                        class="md12 d-flex justify-center"
                    >
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <h2 class="ml-3">
                          การอนุมัติโครงการ
                        </h2>
                        <v-list-item>
                          <v-row class="justify-center">
                            <v-col
                                cols="12"
                                md="6">
                              <v-text-field label="ชื่อเรียก - ระดับขั้น"
                                            v-model="LevelName"></v-text-field>
                            </v-col>
                            <v-col
                                cols="12"
                                md="3">
                              <v-btn outlined color="primary" class="mt-5"
                                     @click="InsertLevel">
                                เพิ่ม
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item v-if="items.length > 0">
                          <v-row class="justify-center">
                            <v-col
                                cols="12"
                                md="12">
                              <v-card>
                                <v-list-item class="justify-center text-center">
                                                      <span style="font-weight: bold;font-size: 16px;color: red">
                                                          **ลำดับการอนุมัติจะเรียงจากบน(ผู้อนุมัติขั้นสุด) - ล่าง(ผู้อนุมัติขั้นต้น)**
                                                      </span>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list dense v-for="(level_i, i) in items"
                                        :key="i">
                                  <v-subheader class="font-weight-bold pa-5">
                                    <span
                                        style="font-weight: bold;font-size: 16px;color: #ff6d81;margin-right: 10px">{{
                                        i + 1
                                      }} )</span>
                                    <span style="font-weight: bold;font-size: 16px;color: #364eff">
                                                                          {{ level_i.LevelName }}
                                                                      </span>
                                  </v-subheader>
                                  <v-list-item-group
                                      v-model="item"
                                      color="primary"
                                  >
                                    <draggable class="list-group" :list="level_i.data"
                                               group="people" @change="log">
                                      <v-list-item
                                          v-for="(level_i, idx) in level_i.data"
                                          :key="idx"
                                      >
                                        <v-list-item-icon>
                                          <v-icon v-text="level_i.icon"></v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                          <v-list-item-title>
                                            <v-chip color="primary"
                                                    class="lighten-1" dark
                                                    style="cursor: pointer">
                                              {{ level_i.full_Name }}
                                            </v-chip>
                                          </v-list-item-title>
                                        </v-list-item-content>
                                      </v-list-item>
                                    </draggable>
                                  </v-list-item-group>
                                </v-list>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <!--<v-list-item class="align-center justify-center">
                            <v-btn color="primary" outlined @click="saveApproveLv">บันทึก</v-btn>
                        </v-list-item>-->
                      </v-col>
                      <v-divider vertical></v-divider>
                      <v-col
                          cols="12"
                          md="5"
                      >
                        <draggable class="list-group" :list="DataToShow" group="people"
                                   @change="log" v-if="dep_id != ''">
                          <v-chip color="primary" class="lighten-1 ml-3" dark
                                  v-for="(person, idx) in DataToShow" v-bind:key="idx"
                                  style="cursor: pointer">
                            {{ person.full_Name }}
                          </v-chip>
                        </draggable>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-container>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <template>
          <v-dialog
              v-model="dialogDelete"
              max-width="290"
          >
            <v-card>
              <v-card-title class="headline">ยืนยันการทำรายการ</v-card-title>

              <v-card-text v-if="permissionDelete != null">
                คุณต้องการลบข้อมูลสิทธิ์การใช้งาน คุณ : {{ permissionDelete.full_Name }} ใช่หรือไม่
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="green darken-1"
                    text
                    @click="deletePermissionData"
                >
                  ตกลง
                </v-btn>
                <v-btn
                    color="red"
                    text
                    @click="dialogDelete = false"
                >
                  ยกเลิก
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </template>
      <template v-else>
        <v-card>
          <v-card-text>
            <v-responsive class="justify-center align-center text-center" height="500px">
                      <span style="font-size: 50px;font-weight: bold">
                               Loading!!
                      </span>
            </v-responsive>
          </v-card-text>
        </v-card>
      </template>
    </template>
    <template>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            :color="appColor"
            dark
        >
          <v-card-text>
            Loading.....
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import axios from "axios";
import ConstData from "@/const/Const";
// import {ServiceProvider} from "@/resource";
import draggable from "vuedraggable";

export default {
  name: "Permission",
  components: {
    draggable
  },
  data() {
    return ({
      dialogLoading: false,
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      searchPermiss: '',
      DataToShowCopy: [],
      dep_id: '',
      list1: [
        {name: "John", id: 1},
        {name: "Joao", id: 2},
        {name: "Jean", id: 3},
        {name: "Gerard", id: 4}
      ],
      list2: [
        {name: "Juan", id: 5},
        {name: "Edgard", id: 6},
        {name: "Johnson", id: 7}
      ],
      LevelName: '',
      item: 1,
      items: [],
      tabTitle: null,
      DataToShow: [],
      CheckAllDepart: false,
      CheckAllSendmail: false,
      search: '',
      DepartDataDupe: [],
      DepartDataDump: [],
      DepartData: [],
      CheckAllOption: false,
      tab: null,
      CheckAdmin: false,
      permissionDelete: null,
      dialogDelete: false,
      perid: '',
      StaffData: [],
      PermissionMsData: [],
      allPermission: [],
      allDepPermission: [],
      HeaderPermiss: [
        {text: 'ชื่อ - สกุล', value: 'Custom'},
        {text: '', value: 'action'},
      ],
      DepHeader: [
        {text: 'ชื่อหน่วยงาน', value: 'full_Name'},
        {text: '', value: 'action'},
      ],
      Option: [
        {text: 'รับการแจ้งเตือนเสนอโครงการผ่าน E-Mail', value: 'email', IsCheck: false}
      ]
    })
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      depart: 'Depart/getDepart',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      OptUserPermission: 'Permission/getOptUserPermission',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initDepartData: 'Depart/initDepartData',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
      initPermissionOptionUserData: 'Permission/initPermissionOptionUserData',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
      changeTypeProject: 'Project/changeTypeProject',
      changeHeaderPage: 'Project/changeHeaderPage',
      changeManageProjectPage: 'Project/changeManageProjectPage',
    }),
    init() {
      this.dialogLoading = true
      var CheckMatch = false
      var CheckMatchDep = false
      var DupePermiss = []
      this.DataToShow = []
      this.allPermission = []
      this.allDepPermission = []
      this.PermissionMsData = []
      this.StaffData = []
      this.DepartData = []
      this.DataToShowCopy = []
      this.items = []
      /*this.$swal.fire({
        title: 'Please Wait !',
        html: '',// add html attribute if you want or remove
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading()
        },
      });*/
      this.initDepartData().then(res => {
        if (res) {
          this.depart.map(depart_i => {
            this.DepartData.push({
              ...depart_i,
              full_Name: depart_i.dep_name + ' ' + depart_i.dep_id + ' ' + '( ' + depart_i.dep_group_name + ' )' + '( ' + depart_i.dep_group_id + ' )',
              dep_permiss: false,
              sendmail: false,
            })
          })
          this.DepartDataDump = this.DepartData

          this.initStaffData().then(async resStaff => {
            if (resStaff) {
              this.dialogLoading = false
              await this.initPermissionUserData({
                perid: this.MeData[0].perid
              }).then(resPer => {
                if (resPer) {
                  if (this.AllPermission.length > 0) {
                    this.depart.map(dep_i => {
                      this.AllPermission.map(permiss_I => {
                        if (dep_i.dep_id == permiss_I.dep_id) {
                          DupePermiss.push({
                            ...permiss_I
                          })
                        }
                      })
                    })
                    if (DupePermiss.length > 0) {
                      DupePermiss.map(allPer => {
                        if (this.DataToShow.length > 0) {
                          CheckMatch = false
                          this.DataToShow.map(allPer2 => {
                            if (allPer.perid == allPer2.perid) {
                              CheckMatch = true
                            }
                          })
                          if (!CheckMatch) {
                            this.allPermission.push({
                              ...allPer,
                              Custom: '<span style="color: blueviolet">(' + allPer.perid + ') ' + allPer.full_Name + '</span>' +
                                  '<div style="color: brown">' + allPer.dep_name + '</div>'
                            })
                            this.DataToShow.push({
                              ...allPer,
                              Custom: '<span style="color: blueviolet">(' + allPer.perid + ') ' + allPer.full_Name + '</span>' +
                                  '<div style="color: brown">' + allPer.dep_name + '</div>'
                            })
                          }
                        } else {
                          this.allPermission.push({
                            ...allPer,
                            Custom: '<span style="color: blueviolet">(' + allPer.perid + ') ' + allPer.full_Name + '</span>' +
                                '<div style="color: brown">' + allPer.dep_name + '</div>'
                          })
                          this.DataToShow.push({
                            ...allPer,
                            Custom: '<span style="color: blueviolet">(' + allPer.perid + ') ' + allPer.full_Name + '</span>' +
                                '<div style="color: brown">' + allPer.dep_name + '</div>'
                          })
                        }
                      })
                    }
                  }
                }
              }).catch(res => {
                if (res) {
                  console.log('catch PermissionUser => ' + res)
                }
              })

              await this.initPermissionDepUserAllData().then(resAllDep => {
                if (resAllDep) {
                  this.DepPermission.map(depPermiss => {
                    this.depart.map(depart_i => {
                      if (depPermiss.dep_id_permiss == depart_i.dep_id) {
                        this.DepartData.push({
                          ...depart_i,
                          full_Name: depart_i.dep_name + '( ' + depart_i.dep_group_name + ' )',
                          dep_permiss: false
                        })
                      }
                    })
                  })
                  this.DepartData.map(dep_i => {
                    if (this.AllDepPermission.length > 0) {
                      this.AllDepPermission.map(data_i => {
                        if (dep_i.dep_id == data_i.dep_id) {
                          if (this.DataToShow.length > 0) {
                            CheckMatchDep = false
                            this.DataToShow.map(allPer2 => {
                              if (data_i.perid == allPer2.perid) {
                                CheckMatchDep = true
                              }
                            })
                            if (!CheckMatchDep) {
                              this.allDepPermission.push({
                                ...data_i,
                                Custom: '<span style="color: blueviolet">(' + data_i.perid + ') ' + data_i.full_Name + '</span>' +
                                    '<div style="color: brown">' + data_i.dep_name + '</div>'
                              })
                              this.DataToShow.push({
                                ...data_i,
                                Custom: '<span style="color: blueviolet">(' + data_i.perid + ') ' + data_i.full_Name + '</span>' +
                                    '<div style="color: brown">' + data_i.dep_name + '</div>'
                              })
                            }
                          } else {
                            this.allDepPermission.push({
                              ...data_i,
                              Custom: '<span style="color: blueviolet">(' + data_i.perid + ') ' + data_i.full_Name + '</span>' +
                                  '<div style="color: brown">' + data_i.dep_name + '</div>'
                            })
                            this.DataToShow.push({
                              ...data_i,
                              Custom: '<span style="color: blueviolet">(' + data_i.perid + ') ' + data_i.full_Name + '</span>' +
                                  '<div style="color: brown">' + data_i.dep_name + '</div>'
                            })
                          }
                        }
                      })
                    }

                    this.DataToShowCopy = JSON.parse(JSON.stringify(this.DataToShow));

                    if (this.staffData.length > 0) {
                      this.staffData.map(staff_i => {
                        if (staff_i.dep_id == dep_i.dep_id) {
                          this.StaffData.push({
                            ...staff_i,
                            fullDetail: '( ' + staff_i.perid + ' )' + ' ' + staff_i.full_Name + ' * ' + staff_i.dep_name + ' *'
                          })
                        }
                      })
                    }
                  })

                  this.$swal.close();
                }
              }).catch(res => {
                if (res) {
                  console.log('catch PermissionDepUserAllDat => ' + res)
                }
              })
            }
          })

          this.getPermissionDep({
            perid: this.MeData[0].perid
          }).then(resDep => {
            if (resDep) {
              this.Permission_Dep.map(dep_i => {
                this.depart.map(depart_i => {
                  if (dep_i.dep_id == depart_i.dep_id) {
                    this.DepartData.push({
                      ...depart_i,
                      full_Name: depart_i.dep_name + '( ' + depart_i.dep_group_name + ' )',
                      dep_permiss: false
                    })
                  }
                })
              })
            }
          })

          this.initPermissionMsData().then(res => {
            if (res) {
              this.getPermissionData({
                perid: this.MeData[0].perid
              }).then(res => {
                if (res) {
                  var CheckPermiss = false
                  this.Permission_Ms.map(per_i => {
                    CheckPermiss = false
                    this.PermissionAdmin.map(per_d_i => {
                      if (per_i.id == per_d_i.permission_id) {
                        CheckPermiss = true
                      }
                    })

                    if (CheckPermiss) {
                      this.PermissionMsData.push({
                        ...per_i,
                        permiss: false,
                        disable: false
                      })
                    } else {
                      this.PermissionMsData.push({
                        ...per_i,
                        permiss: false,
                        disable: true
                      })
                    }
                  })
                }
              })
            }
          })
        } else {
          // this.$swal.close();
          this.dialogLoading = false
        }
      }).catch(resCatch => {
        if (resCatch) {
          this.dialogLoading = false
        }
      })
    },
    ChooseApproveDep() {
      this.items = []
      this.DataToShow = JSON.parse(JSON.stringify(this.DataToShowCopy));
      this.DataToShow.push({
        perid: this.MeData[0].perid,
        full_Name: this.MeData[0].full_Name,
        name: this.MeData[0].name,
        surname: this.MeData[0].surname,
        dep_id: this.MeData[0].dep_id,
        dep_group_id: this.MeData[0].dep_group_id,
        dep_name: this.MeData[0].dep_name,
        dep_group_name: this.MeData[0].dep_group_name,
      })
      this.initApproveMsData({
        dep_id: this.dep_id
      }).then(res => {
        if (res) {
          if (this.Approve_Ms.length > 0) {
            this.Approve_Ms.map(App_i => {
              this.items.push({
                LevelName: App_i.name,
                level: App_i.level,
                data: [],
                ...App_i
              })
            })
          }
          this.initApproveData().then(res => {
            if (res) {
              if (this.Approve.length > 0) {
                this.items.map(item => {
                  this.Approve.map(App_i => {
                    if (item.id == App_i.approve_id) {
                      item.data.push({
                        ...App_i
                      })
                      if (this.DataToShow.length > 0) {
                        this.DataToShow = this.DataToShow.filter(dataToShow_i => dataToShow_i.perid != App_i.perid)
                      }
                    }
                  })
                })
              }
            }
          })
        }
      })
    },
    saveApproveLv() {
      var headerAxios = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      this.items.map((item, idx) => {
        if (item.data.length > 0) {
          item.data.map(data_i => {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Approve_Ms/dep_id/' + this.dep_id + '/level/' + item.level + '/?limit=9999').then((res) => {
              if (res.data) {
                var ApproveMsResult = res.data
                axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Approve/perid/' + data_i.perid + '/approve_id/' + res.data.id + '/?limit=9999').then((res) => {
                  if (res.data) {
                    console.log('----')
                    console.log(res.data)
                    console.log('----')
                  } else {
                    const params = {
                      perid: data_i.perid,
                      approve_id: ApproveMsResult.id,
                      create_by: this.MeData[0].perid
                    }
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Approve/', params, headerAxios).then((res) => {
                      if (res.data.status) {
                        if (idx === this.items.length - 1) {
                          this.$swal.fire({
                            icon: 'success',
                            title: 'บันทึกข้อมูลสำเร็จ'
                          })
                        }
                      }
                    })
                  }
                })
              }
            })
          })
        }
      })
    },
    add: function () {
      this.list.push({name: "Juan"});
    },
    replace: function () {
      this.list = [{name: "Edgard"}];
    },
    clone: function (el) {
      return {
        name: el.name + " cloned"
      };
    },
    log: function (evt) {
      var headerAxios = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'DELETE'
        }
      }
      if (evt.removed != null) {
        var dataFilter = this.DataToShow.filter(data => data.perid == evt.removed.element.perid)
        if (dataFilter.length > 0) {
          headerAxios = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'DELETE'
            }
          }
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Approve_view/perid/' + dataFilter[0].perid + '/approve_dep_id/' + this.dep_id).then((res) => {
            if (res.data) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Approve/approve_id/' + res.data.approve_id + '/perid/' + res.data.perid, '', headerAxios).then((res) => {
                if (!res.data.status) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด โปรดตรวจสอบการเชื่อมต่ออินเตอร์เน็ต'
                  })
                }
              })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด โปรดตรวจสอบการเชื่อมต่ออินเตอร์เน็ต'
              })
            }
          })
        } else {
          this.items.map(item => {
            if (item.data.length > 0) {
              item.data.map(data_i => {
                if (data_i.perid == evt.removed.element.perid) {
                  axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Approve_view/perid/' + data_i.perid + '/approve_dep_id/' + this.dep_id).then((res) => {
                    if (res.data) {
                      headerAxios = {
                        headers: {
                          'Content-Type': 'application/json',
                        }
                      }
                      const params = {
                        approve_id: item.id,
                      }
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Approve/perid/' + data_i.perid + '/approve_id/' + res.data.approve_id, params, headerAxios).then((res) => {
                        if (!res.data.status) {
                          this.$swal.fire({
                            icon: 'error',
                            title: 'พบข้อผิดพลาด โปรดตรวจสอบการเชื่อมต่ออินเตอร์เน็ต'
                          })
                        }
                      })
                    } else {
                      headerAxios = {
                        headers: {
                          'Content-Type': 'application/json',
                          'X-REST-METHOD': 'PUT'
                        }
                      }
                      const params = {
                        perid: data_i.perid,
                        approve_id: item.id,
                        create_by: this.MeData[0].perid
                      }
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Approve/', params, headerAxios).then((res) => {
                        if (!res.data.status) {
                          this.$swal.fire({
                            icon: 'error',
                            title: 'พบข้อผิดพลาด โปรดตรวจสอบการเชื่อมต่ออินเตอร์เน็ต'
                          })
                        }
                      })
                    }
                  })
                }
              })
            }
          })
        }
      }
    },
    InsertLevel() {
      var headerAxios = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      if (this.LevelName != '' && this.dep_id != '') {
        const params = {
          name: this.LevelName,
          level: this.items.length + 1,
          dep_id: this.dep_id,
          create_by: this.MeData[0].perid
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Approve_Ms/', params, headerAxios).then((res) => {
          if (res.data.status) {
            this.items.push({
              LevelName: this.LevelName,
              level: this.items.length + 1,
              data: []
            })
            this.LevelName = ''
          }
        })
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดกรอกข้อมูลให้ครบถ้วน'
        })
      }
    },
    DeletePermiss(item) {
      this.permissionDelete = null
      this.permissionDelete = item
      this.dialogDelete = true
    },
    deletePermissionData() {
      this.initMeData().then(res => {
        if (res) {
          if (this.permissionDelete != null) {
            axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
              queryName: 'delSettingPermission',
              param: btoa(encodeURIComponent(JSON.stringify({
                perid: this.permissionDelete.perid,
                perid_exec: this.MeData[0].perid,
                type: 'user',
              })))
            }).then(res => {
              if (res.data.status) {
                this.$swal.fire({
                  icon: 'success',
                  title: 'ลบข้อมูลสำเร็จ'
                })
                this.dialogDelete = false
                this.init()
                this.cancelAllPermiss()
                this.cancelAllPermissDep()
                this.CheckAllSendmailFunc()
                this.CheckAllDepart = false
                this.CheckAllSendmail = false
                this.permissionDelete = null
                this.perid = ''
              }
            })
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด กรุณาเลือกข้อมูลที่ต้องการลบ'
            })
          }
        }
      })
    },
    ShowDetailPermiss(item) {
      this.ChooseAllDep()
      this.perid = item.perid
      this.ChoosePerson()
    },
    filterItem() {
      this.DepartDataDump = this.DepartData.filter(item => item.full_Name.indexOf(this.search) >= 0)
    },
    ChooseAllDep() {
      this.search = ''
      if (this.DepartDataDupe.length == 0) {
        this.DepartDataDupe = this.DepartData
      }
      this.DepartDataDump = this.DepartDataDupe
    },
    ChooseDepPermiss() {
      this.search = ''
      if (this.DepartDataDupe.length == 0) {
        this.DepartDataDupe = this.DepartData
      }
      this.DepartDataDump = this.DepartDataDump.filter(dep_i => dep_i.dep_permiss)
    },
    cancelAllOptPermiss() {
      this.Option.map(item => item.IsCheck = false)
    },
    CheckAllPermissDep() {
      // this.search = ''
      // this.ChooseAllDep()
      if (this.CheckAllDepart) {
        this.DepartDataDump.map(dep_i => {
          dep_i.dep_permiss = true
        })
      } else {
        this.cancelAllPermissDep()
      }
    },
    CheckAllSendmailFunc() {
      if (this.CheckAllSendmail) {
        this.DepartDataDump.map(dep_i => {
          dep_i.sendmail = true
        })
      } else {
        this.cancelAllSendmail()
      }
    },
    cancelAllPermissDep() {
      this.DepartDataDump.map(dep_i => {
        dep_i.dep_permiss = false
      })
    },
    cancelAllSendmail() {
      this.DepartDataDump.map(dep_i => {
        dep_i.sendmail = false
      })
    },
    CheckAllPermiss() {
      if (this.CheckAllOption) {
        this.PermissionMsData.map(per_i => {
          if (per_i.disable) {
            per_i.permiss = false
          } else {
            per_i.permiss = true
          }
        })
      } else {
        this.cancelAllPermiss()
      }
    },
    cancelAllPermiss() {
      this.PermissionMsData.map(per_i => {
        per_i.permiss = false
      })
    },
    ChoosePerson() {
      this.cancelAllPermiss()
      this.getPermissionUserData({
        perid: this.perid
      }).then(res => {
        if (res) {
          this.PermissionMsData.map(PerMs_i => {
            this.Permission.map(Per_i => {
              if (PerMs_i.id == Per_i.permission_id) {
                PerMs_i.permiss = true
              }
            })
          })
        }
      })
      this.ChooseDepart()
      this.ChooseOption()
    },
    ChooseDepart() {
      this.cancelAllPermissDep()
      this.getPermissionDepUserData({
        perid: this.perid
      }).then(res => {
        if (res) {
          this.Permission_Dep_User.map(PerDep_i => {
            this.DepartDataDump.map(Dep_i => {
              if (PerDep_i.dep_id == Dep_i.dep_id) {
                Dep_i.dep_permiss = true
                Dep_i.sendmail = PerDep_i.sendmail == '1' ? true : false
              }
            })
          })
        }
      })
    },
    ChooseOption() {
      this.cancelAllOptPermiss()
      this.initPermissionOptionUserData({
        perid: this.perid
      }).then(res => {
        if (res) {
          this.OptUserPermission.map(optI => {
            this.Option.map(optI2 => {
              if (optI2.value == 'email') {
                if (optI.email == '1') {
                  optI2.IsCheck = true
                }
              }
            })
          })
        }
      })
    },
    SubmitData() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการยืนยัน",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          if (this.perid != '') {
            this.dialogLoading = true
            var CheckChoice = this.PermissionMsData.filter(perms_i => perms_i.permiss)
            var CheckChoiceDep = this.DepartDataDump.filter(perms_i => perms_i.dep_permiss)
            axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
              queryName: 'saveSettingPermission',
              param: btoa(encodeURIComponent(JSON.stringify({
                permissionSet: CheckChoice,
                permissionDep: CheckChoiceDep,
                perid: this.perid,
                perid_exec: this.MeData[0].perid,
                type: 'user',
              })))
            }).then(async res => {
              if (res.data.status) {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'success',
                  title: 'บันทึกข้อมูลสำเร็จ'
                })
                this.init()
                this.cancelAllPermiss()
                this.CheckAllDepart = false
                this.CheckAllSendmail = false
                this.perid = ''
              } else {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถุบันทึกข้อมูลได้โปรดลองอีกครั้ง'
                })
              }
            })
          } else {
            this.dialogLoading = false
            this.$swal.fire({
              icon: 'error',
              title: 'โปรดเลือกบุคลากรที่ต้องการบันทึกสิทธิ์'
            })
          }
        }
      })
    },
    SubmitDepartData() {
      var headerAxios = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      if (this.perid != '') {
        this.$swal.fire({
          title: 'Please Wait !',
          html: 'กำลังบันทึกข้อมูล',// add html attribute if you want or remove
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          },
        });
        var CheckChoice = this.DepartData.filter(perms_i => perms_i.dep_permiss)
        var CheckPermiss = this.DepPermission.filter(perms_i => perms_i.perid == this.perid)
        if (CheckPermiss.length > 0) {
          const headerAxiosDel = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'DELETE'
            }
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Permission_Depart_User/perid/' + this.perid, '', headerAxiosDel).then(res => {
            if (res.data.status) {
              if (CheckChoice.length > 0) {
                CheckChoice.map((depart, idx) => {
                  headerAxios = {
                    headers: {
                      'Content-Type': 'application/json',
                      'X-REST-METHOD': 'PUT'
                    }
                  }
                  const params = {
                    perid: this.perid,
                    dep_id: depart.dep_id,
                  }
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Permission_Depart_User/', params, headerAxios).then(res => {
                    if (res.data.status) {
                      if (idx == CheckChoice.length - 1) {
                        this.$swal.close();
                        this.$swal.fire({
                          icon: 'success',
                          title: 'บันทึกข้อมูลสำเร็จ'
                        })
                        this.init()
                        this.cancelAllPermissDep()
                        this.perid = ''
                      }
                    } else {
                      this.$swal.close();
                      this.$swal.fire({
                        icon: 'success',
                        title: 'บันทึกข้อมูลสำเร็จ'
                      })
                      this.init()
                      this.cancelAllPermissDep()
                      this.perid = ''
                    }
                  })
                })
              } else {
                this.$swal.close();
                this.$swal.fire({
                  icon: 'success',
                  title: 'บันทึกข้อมูลสำเร็จ'
                })
                this.init()
                this.cancelAllPermissDep()
                this.perid = ''
              }
            }
          })
        } else {
          const headerAxiosDel = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'DELETE'
            }
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Permission_Depart_User/perid/' + this.perid, '', headerAxiosDel).then(res => {
            if (res.data.status) {
              if (CheckChoice.length > 0) {
                CheckChoice.map((depart_i, idx) => {
                  headerAxios = {
                    headers: {
                      'Content-Type': 'application/json',
                      'X-REST-METHOD': 'PUT'
                    }
                  }
                  const params = {
                    perid: this.perid,
                    dep_id: depart_i.dep_id,
                  }
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Permission_Depart_User/', params, headerAxios).then(res => {
                    if (res.data.status) {
                      if (idx == CheckChoice.length - 1) {
                        this.$swal.close();
                        this.$swal.fire({
                          icon: 'success',
                          title: 'บันทึกข้อมูลสำเร็จ'
                        })
                        this.init()
                        this.cancelAllPermissDep()
                        this.perid = ''
                      }
                    } else {
                      this.$swal.close();
                      this.$swal.fire({
                        icon: 'success',
                        title: 'บันทึกข้อมูลสำเร็จ'
                      })
                      this.init()
                      this.cancelAllPermissDep()
                      this.perid = ''
                    }
                  })
                })
              } else {
                this.$swal.close();
                this.$swal.fire({
                  icon: 'success',
                  title: 'บันทึกข้อมูลสำเร็จ'
                })
                this.init()
                this.cancelAllPermissDep()
                this.perid = ''
              }
            }
          })
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดเลือกบุคลากรที่ต้องการบันทึกสิทธิ์'
        })
      }
    },
    SubmitOptionData(perid) {
      var headerAxios = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      if (perid != '') {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Permission_Option_User/perid/' + perid).then(res => {
          if (res.data) {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Permission_Option_User/perid/' + perid, {
              email: this.Option[0].IsCheck ? '1' : '0'
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(resUpdate => {
              if (resUpdate.data.staffData) {
                this.cancelAllOptPermiss()
              }
            })
          } else {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Permission_Option_User', {
              email: this.Option[0].IsCheck ? '1' : '0',
              perid: perid,
              create_by: this.MeData[0].perid
            }, headerAxios).then(resPut => {
              if (resPut.data.status) {
                this.cancelAllOptPermiss()
              }
            })
          }
        }).catch(res => {
          if (res) {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Permission_Option_User', {
              email: this.Option[0].IsCheck ? '1' : '0',
              perid: perid
            }, headerAxios).then(resPut => {
              if (resPut.data.status) {
                this.cancelAllOptPermiss()
              }
            })
          }
        })
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดเลือกบุคลากรที่ต้องการบันทึกสิทธิ์'
        })
      }
    }
  },
  mounted() {
    // this.$vuetify.theme.themes.light.primary = '#4caf50' // theme
    this.changeColor({
      color: ConstData.defaultColorApp
    })
    this.changeHeaderName({
      headerName: ConstData.defaultHeaderApp
    })
    this.changeTypeProject({
      type: null
    })
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '23'
        })
        this.getMenuPermissData().then(res => {
          if (res) {
            if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '23' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
              this.maintain = false
              this.getPermissionData({
                perid: this.MeData[0].perid
              }).then(res => {
                if (res) {
                  if (this.PermissionAdmin.length == 0) {
                    this.$router.push('/')
                  } else {
                    this.CheckAdmin = true
                    this.init()
                  }
                } else {
                  this.$router.push('/')
                }
              })
            } else {
              this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '23' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '23')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
              this.maintain = true
            }
          }
        }).catch(err => {
          if (err) {
            this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '23' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '23')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
            this.maintain = true
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>
